import { render, staticRenderFns } from "./AccidentCommForm.vue?vue&type=template&id=1ebe7f72"
import script from "./AccidentCommForm.vue?vue&type=script&lang=js"
export * from "./AccidentCommForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentCommForm.vue?vue&type=style&index=0&id=1ebe7f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports